import type { QueryClient } from '@tanstack/react-query';
import {
  createSetQueryData,
  updateArrayItem,
} from 'shared/lib/updateQueryArrayProp';

import { fileStorageQueryKeys } from '@/enteties/file-storage/api/file-storage.query-key';
import type { AppBackup, BackupSse } from '@/enteties/file-storage/model';

const dataBackupStatusHandler = (data: BackupSse, queryClient: QueryClient) => {
  const { status, createdAt, serviceSlug } = data.payload;

  const updater = createSetQueryData(
    queryClient,
    fileStorageQueryKeys.projectBackups(serviceSlug)
  );

  updateArrayItem<AppBackup>(
    updater,
    (backup) => backup.createdAt === createdAt,
    { status }
  );
};

export { dataBackupStatusHandler };
